import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import SearchBox from '../courses/searchBox';
import { fetchRequest as getCourseRecomAction} from '../../store/courseRecommend/actions'
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, CardFooter,
    CardSubtitle, CardBody, Spinner, Button
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Redirect } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
}

interface IState {
    redirect: boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseRecomAction
}

type AllProps = PropsFromState & PropsFromDispatch

class HowItWorks extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 4,
            redirect: false
        };
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props
        var searchParams:any = {};
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        if (data.length === 0)
           fr(searchParams);
    }

    private Search(d:any) { 

       this.setState({
            offset : 0, 
            redirect : true,
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {
        });
    }
   
    public render() {

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' ,
                    search :'?term=' + this.state.term  + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country    
                }} />
                // <Redirect to={"/courses?term=" + this.state.term 
                //     + "&profession=" + this.state.profession
                //     + "&country=" + this.state.country    
                //  } />
            )
        }else{
            return (
                <Container>
                    <Col lg="12">
                        <h1 style={{textAlign: "left"}}>How It Works</h1>
                    </Col>
                    <hr/>
                   <br/>
                   <h3 style={{textAlign: "center"}}>NEW USER</h3>                   
                   <br/>
                   <Row>
                       <Col lg="3" xs="6">
                            <img alt="Skote" src="./images/newuser.png" className="img-fluid card-img" />
                        </Col>
                        <Col lg="9" xs="12">
                            STEP 1 : Sign Up with your email <br />
                            STEP 2 : Validation Your email <br />
                            STEP 3 : Click Sign In and complete your details with face recognition <br />
                            STEP 4 : Subscribe to courses you interested<br />
                            STEP 5 : Check out and Make Payment <br />
                            STEP 6 : Proceed to Watch <br />
                            STEP 7 : Download your certificate <br />
                        </Col>
                    </Row>
                    <hr/>
                    <h3 style={{textAlign: "center"}}>EXISTING USER</h3>                   
                    <br/>
                    <Row>
                        <Col lg="3" xs="6">
                            <img alt="Skote" src="./images/existinguser.png" className="img-fluid card-img" />
                        </Col>
                        <Col lg="9" xs="12">
                            STEP 1 : Login <br />
                            STEP 2 : Subscribe to courses you interested<br />
                            STEP 3 : Check out and Make Payment <br />
                            STEP 4 : Proceed to Watch <br />
                            STEP 5 : Download your certificate <br />
                        </Col>
                    </Row>
                    <hr/>
                    {/* <h3 style={{textAlign: "center"}}>TRAINERS</h3>                   
                    <br/>
                    <Row>
                        <Col lg="6" xs="6">
                            <img alt="Skote" className="img-fluid card-img" />
                        </Col>
                        <Col lg="6" xs="6">
                            STEP 1: Login <br />
                            STEP 2: Select Course <br />
                            STEP 3: Click Upload VIDEO <br />
                            STEP 4: Click Upload SLIDES <br />
                            STEP 5: Select CONCENTRATE QUESTIONS <br />
                            STEP 6: Click SAVE <br />
                        </Col>
                    </Row> */}
                   <br /><br /><br /><br /><br /><br /><br />
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourseRecom(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseRecomAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HowItWorks)
